import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { Country } from '/@/modules/predefined/models/Country';
import { PredefinedCountry } from '/@/modules/predefined/enums/PredefinedCountry';
import { PredefinedJurisdiction } from '/@/modules/predefined/enums/PredefinedJurisdiction';

export class Jurisdiction extends BaseModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  code;

  /**
   * @var {int}
   */
  countryId;

  /**
   * @var {string}
   */
  countryName;

  /**
   * @var {Country}
   */
  country;

  /**
   * @var {string}
   */
  administrativeDivisionDescriptor;

  /**
   * @var {boolean}
   */
  isGeneric;

  /**
   * @var {boolean}
   */
  hasNotificationForms;

  constructor(model = {}) {
    super();

    this.id = model.id;
    this.name = model.name;
    this.code = model.code;
    this.countryId = model.countryId;
    this.countryName = model.countryName;
    this.country = Country.mapModelOrNull(model.country);
    this.administrativeDivisionDescriptor = model.administrativeDivisionDescriptor;
    this.isGeneric = model.isGeneric;
    this.hasNotificationForms = model.hasNotificationForms;
  }

  /**
   * @returns {?boolean}
   */
  get isInCanada() {
    return this.countryId === PredefinedCountry.CANADA.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInQuebec() {
    return this.id === PredefinedJurisdiction.QUEBEC.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInPrinceEdwardIsland() {
    return this.id === PredefinedJurisdiction.PRINCE_EDWARD_ISLAND.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInSaskatchewan() {
    return this.id === PredefinedJurisdiction.SASKATCHEWAN.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInOntario() {
    return this.id === PredefinedJurisdiction.ONTARIO.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInAlberta() {
    return this.id === PredefinedJurisdiction.ALBERTA.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInManitoba() {
    return this.id === PredefinedJurisdiction.MANITOBA.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInNovaScotia() {
    return this.id === PredefinedJurisdiction.NOVA_SCOTIA.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInUnitedStates() {
    return this.countryId === PredefinedCountry.UNITED_STATES.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInNewfoundland() {
    return this.id === PredefinedJurisdiction.NEWFOUNDLAND_AND_LABRADOR.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInNewBrunswick() {
    return this.id === PredefinedJurisdiction.NEW_BRUNSWICK.id;
  }

  get isInBritishColumbia() {
    return this.id === PredefinedJurisdiction.BRITISH_COLUMBIA.id;
  }

  /**
   * @returns {?boolean}
   */
  get isInCalifornia() {
    return this.id === PredefinedJurisdiction.CALIFORNIA.id;
  }

  /**
   * @returns {JurisdictionLanguage[]|null}
   */
  getLanguages() {
    return PredefinedJurisdiction.getByKey(this.id, 'id')?.languages ?? [];
  }
}
